export default __webpack_public_path__ + "static/media/NoDataLight.3b6bbd84.svg";